module.exports = __webpack_public_path__ + "static/media/adult-beautiful-brunette-1549280.8c70ab86.jpg";